import { Organization } from '@rematter/frontend-lib-api-client';

export const isAdminOrganization = (
  organization: Organization | null,
): boolean => organization?.domain === 'rematter.com';
